import { isRequiredField, validateRules } from '@foradevelopment/fora-ui';

import { isDateAfterMonthlyReportingStart } from './helpers/isDateAfterMonthlyReportingStart';
import { isAfterDate } from './helpers/isAfterDate';
import { isParameterDateWithinValidityPeriod } from './helpers/isParameterDateWithinValidityPeriod';
import { typedT } from '../../../i18n/i18n';

/** Used for non-pension (fixed) parameter start dates
 * Validation should not be needed since the datepicker forces a certain range. This is to cover if the datepicker does not work properly.
 */
export const validateParameterStartDate =
  (
    monthlyReportingReleaseDate: string,
    employmentStartDate: string,
    fokParameterValidity?: { validFrom: string; validTo: string | null }
  ) =>
  (value: string) => {
    // Only return one error message if value is missing altogether
    const isRequiredValidation = isRequiredField(typedT('errorMessages.validation.parameterStartDate1'))(value);
    if (isRequiredValidation.error) {
      return [isRequiredValidation.errorMessage];
    }

    const rules = [
      isDateAfterMonthlyReportingStart(
        typedT('errorMessages.validation.parameterStartDate2', { monthlyReportingReleaseDate }),
        monthlyReportingReleaseDate
      ),
      isAfterDate(typedT('errorMessages.validation.parameterStartDate3'), employmentStartDate),
    ];

    if (fokParameterValidity) {
      rules.push(
        isParameterDateWithinValidityPeriod(
          typedT('errorMessages.validation.parameterStartDate4'),
          fokParameterValidity
        )
      );
    }

    return validateRules(rules, value);
  };
